var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"size":"","title":_vm.changeTitle(),"dialog-class":"modal-fullscreen","hide-footer":""},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[(_vm.type == 'policy')?_c('Policy'):(_vm.type == 'term')?_c('Term',{attrs:{"brand":_vm.brand,"isPdf":_vm.isPdf}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }